export default __webpack_public_path__ + "static/media/componentkit.b256caae.svg";